"use client";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";
import {Form, FormField} from "@/components/ui/form";
import {useState} from "react";
import {useRouter} from "next/navigation";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import CWFTextarea from "@/components/ui/CWFTextarea";
import CWFSelect from "@/components/ui/CWFSelect";
import CWFFileDropzone from "@/components/ui/CWFFileDropzone";
import CWFButton from "@/components/ui/CWFButton";
import toast from "react-hot-toast";

const REQUIRED_ERROR="Ce champs est requis";
const postSchema = yup.object({
    content : yup.string().nullable(),
    activity_id : yup.number().nullable(),
    training_id : yup.number().nullable(),
    media : yup.mixed().nullable(),
});
export default function UpdatePosts({id,openUpdate, setOpenUpdate, activities, trainings, activityId, trainingId,content}){
    const axios = useAxiosAuth();
    const router = useRouter();

    const [loading, setLoading] = useState(false);
    const [dropzoneKey, setDropzoneKey] = useState(false);

    const formPost = useForm({
        resolver : yupResolver(postSchema),
        defaultValues : {
            content : content,
            activity_id : activityId?.toString(),
            training_id: trainingId?.toString(),
        }
    })

    function updatePost(data){
        const dataWithoutDoc = {...data, media : null};

        axios.put(`posts/${id}`,dataWithoutDoc)
            .then(() => {
                if(data.media){
                    axios.postForm(`social-documents/posts/${id}`, {
                        file : data.media[0],
                    })
                    .catch(() => toast.error("Une erreur s'est produite lors de l'envoi du media"))
                }
            })
            .catch(() => toast.error("Une erreur s'est produite"))
            .finally(() => {
                setOpenUpdate(false);
                router.refresh();
            })
    }

    return (
        <CWFResponsiveDialog
            onOpenChange={setOpenUpdate}
            open={openUpdate}
            title={<p>Mis à jour du post</p>}
            trigger={null}
        >
            <Form {...formPost}>
                <form onSubmit={formPost.handleSubmit(updatePost)} className={"grid gap-4"}>
                    <CWFTextarea placeholder={"Quoi de neuf ? "} name={"content"}
                                 control={formPost.control}/>
                    <CWFSelect control={formPost.control} name={"activity_id"} label={"Activité"}
                               items={activities}/>
                    <CWFSelect control={formPost.control} name={"training_id"} label={"Open Training"}
                               items={trainings}/>
                    <FormField
                        control={formPost.control}
                        name={"media"}
                        render={({field, fieldState}) => (
                            <div className={""}>
                                <label>Photo / Vidéo</label>
                                <CWFFileDropzone
                                    maxFiles={1}
                                    maxSize={100000000}
                                    accept={{
                                        'image/*' : ['.png', '.jpg', '.jpeg','gif'],
                                        'video/*' : ['.mp4'],
                                        '*' : ['.svg']
                                    }}
                                    acceptInfo={"Png, jpg, jpeg, gif,svg, mp4"}
                                    key={dropzoneKey}
                                    onDrop={field.onChange}
                                    error={fieldState.error}
                                />
                            </div>
                        )}
                    />
                    <div className={"flex justify-center"}>
                        <CWFButton loading={loading}>Mettre à jour</CWFButton>
                    </div>
                </form>
            </Form>
        </CWFResponsiveDialog>)
}